import React from "react";
import Spritesheet from 'react-responsive-spritesheet';
import TextBox from "../../TextBox";

import img from './images/1.png';

const width = 1089 / 6;
const height = 170 / 1;

const CompetitionLogo = (props) => {

    return <div className="position-relative" >
        <div className={`mb-1 d-inline-block`} >
            <Spritesheet
                image={img}
                widthFrame={width}
                heightFrame={height}
                steps={6}
                startAt={1}
                endAt={6}
                fps={12}
                autoplay={true}
                loop={true}
            />
        </div>
        <TextBox {...props} />
    </div >
}

export default CompetitionLogo;